import axios from '@/axios.js';
const url = 'https://soonsmart.keji.io/';

const build_aliOssFormData = async () => {
    let ossSts = JSON.parse(localStorage.getItem('osssts'));
    if (!ossSts || new Date(ossSts.Expiration) <= new Date()) {
        let data = await axios.get('https://sts.aliyun.keji.io/osssts/getsecuritytoken?identify=charging')
        data.Expiration = new Date(data.Expiration)
        data.Expiration.setHours(data.Expiration.getHours() + 8)
        data.ExpirationTime = data.Expiration.getTime()
        localStorage.setItem('osssts', JSON.stringify(data))
        ossSts = data;
    }
    return ossSts;
}

/**
 * 
 * @param file 
 * @param uploadPath 
 * @returns 
 */
const _uploadFileOssH5 = async (file, uploadPath) => {
    var OSS = require('ali-oss')
    try {
        const ossSts = await build_aliOssFormData();
        console.log('oss_sts', ossSts);
        const oss = new OSS({
            region: "oss-cn-qingdao",
            accessKeyId: ossSts.AccessKeyId,
            accessKeySecret: ossSts.AccessKeySecret,
            stsToken: ossSts.SecurityToken,
            bucket: "soon-smart",
            refreshSTSToken: async () => {
                const resToken = await build_aliOssFormData();
                return {
                    accessKeyId: resToken.AccessKeyId,
                    accessKeySecret: resToken.AccessKeySecret,
                    stsToken: resToken.SecurityToken
                };
            },
            refreshSTSTokenInterval: 8 * 3600 * 1000,//8小时
        });
        const res = await oss.multipartUpload(uploadPath, file, {})
        console.log('uploadFileOssH5 success', res);
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
    * 上传图片
    * @param tempFiles ImageFile[]
    * @returns 不含fileHost的图片地址
    */
export const uploadFiles = async (imgName, imgFile) => {
    try {
        let ext = imgName
            .substring(imgName.lastIndexOf('.') + 1)
            .toLowerCase()
        let now = new Date()
        let key =
            now.getFullYear() +
            '-' +
            (now.getMonth() * 1 + 1) +
            '/' +
            now.getDate() +
            '/' +
            now.getTime() +
            '.' +
            ext

        let uploadPath = "/ild/" + key;

        const resUpload = await _uploadFileOssH5(imgFile, uploadPath)
        console.log("图片上传地址", resUpload);
        return Promise.resolve(resUpload);

    } catch (err) {
        console.log('uploadFileOss fail', err);
        return Promise.reject(err);
    }
}
